import { render, staticRenderFns } from "./addVehicleRoadTax.vue?vue&type=template&id=28bc0626"
import script from "./addVehicleRoadTax.vue?vue&type=script&lang=js"
export * from "./addVehicleRoadTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports